import React, { useState } from 'react'
import Slider from '../Common/Slider'
import { Link } from 'react-router-dom'

const Home = () => {
    const [isOpen, setIsOpen] = useState(true);

	const openPopup = () => {
	  setIsOpen(true);
	};
  
	const closePopup = () => {
	  setIsOpen(false);
	};

  return (
    <>
        <Slider />

        <section class="p-0 overflow-visible service-block">
            <div class="container">
                <div class="row mt-n1-9">    
                    <div class="col-md-6 col-lg-4 mt-1-9">
                        <div class="card card-style3 h-100">
                        <div class="card-body px-1-9 py-2-3">
                            <div class="mb-3 d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="fas fa-mail-bulk"></i>
                                </div>
                                <h4 class="ms-4 mb-0">PCI Approval</h4>
                            </div>
                            <div>
                                <p class="mb-3">MGIMS is approved by Pharmacy Council of India (PCI) New Delhi.</p>
                                <Link to={'/img/pdf/pci_approval_letter_mgip_2023_24.pdf'} class="butn-style1 secondary" target='blank'>Click Here +</Link>
                            </div>
                        </div>
                        </div>
                    </div>                
                    <div class="col-md-6 col-lg-4 mt-1-9">
                        <div class="card card-style3 h-100">
                        <div class="card-body px-1-9 py-2-3">
                            <div class="mb-3 d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="fas fa-map"></i>
                                </div>
                                <h4 class="ms-4 mb-0">Admission Form</h4>
                            </div>
                            <div>
                                <p class="mb-3">Click below to Download the Admission form of MGIMS Lucknow.</p>
                                <Link to={'/img/pdf/admission_form.pdf'} class="butn-style1 secondary" target='blank'>Click Here +</Link>
                            </div>
                        </div>
                        </div>
                    </div>
                    
                    <div class="col-md-6 col-lg-4 mt-1-9">
                        <div class="card card-style3 h-100">
                        <div class="card-body px-1-9 py-2-3">
                            <div class="mb-3 d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="fas fa-mail-bulk"></i>
                                </div>
                                <h4 class="ms-4 mb-0">BTE Affiliation</h4>
                            </div>
                            <div>
                                <p class="mb-3">MGIMS is affiliated with Board of Technical Education Lucknow Uttar Pradesh.</p>
                                <Link to={'/img/pdf/bte_approval_letter_mgims_2023_24.pdf'} class="butn-style1 secondary" target='blank'>Click Here +</Link>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            </section>


            {/* <!-- ABOUTUS
        ================================================== --> */}
        <section class="aboutus-style-01 position-relative">
            <div class="container pt-lg-4">
                <div class="row align-items-center mt-n1-9">
                    <div class="col-md-12 col-lg-6 mt-1-9 order-2 order-lg-1">
                        <div class="position-relative">                            
                                <div className='image-hover'>
                                    <img src="img/content/pharma-04.png" alt="..." class="ps-sm-10" />
                                </div>  
                        </div>   
                    </div>
                    <div class="col-md-12 col-lg-6 mt-1-9 order-2 order-lg-1">
                        <div class="section-heading text-start mb-2">
                            <span class="sub-title">welcome!</span>
                        </div>
                        <h2 class="font-weight-800 h1 mb-1-9 text-primary">Mahatma Gandhi Institute of Medical Sciences</h2>
                        <p class="about-border lead fst-italic mb-1-9">We are highly captivated to welcome you all in Mahatma Gandhi Institute of Medical Sciences (MGIMS), where education does not commence only with the 'Books'.</p>
                        <blockquote>
                        Our aim is to impart all round quality education to the Students with a view to shape them into well rounded, well-adjusted and well-tuned Professionals, capable of making their future in various walks of life. We are designed to achieve efficient prefectural system in pharmacy for students.
                        </blockquote>
                        <div class="dotted-seprator pt-1-9 mt-1-9"></div>
                        <div class="row">
                            <div class="col-sm-6 col-12 mb-3 mb-sm-0">
                                <div class="media">
                                    <i class="fas fa-phone display-15 text-secondary"></i>
                                    <div class="media-body align-self-center ms-3">
                                        <h4 class="mb-1 h5">Phone Number</h4>
                                        <p class="mb-0"><Link to={'tel:+91 9935844704'}>+91 9935844704</Link></p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-12">
                                <div class="media">
                                    <i class="fas fa-envelope display-15 text-secondary"></i>
                                    <div class="media-body align-self-center ms-3">
                                        <h4 class="mb-1 h5">Email Address</h4>
                                        <p class="mb-0"><Link to={'mailto:mgimedicalsciences@gmail.com'} className='text-nowrap'>mgimedicalsciences@gmail.com</Link></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="shape18">
                    <img src="img/bg-01.jpg" alt="..." />
                </div>
                <div class="shape20">
                    <img src="img/bg-02.jpg" alt="..." />
                </div>
            </div>
        </section>

       

        {/* <!-- TRENDING CATEGORIES
        ================================================== --> */}
        <section class="bg-img cover-background dark-overlay" style = {{backgroundImage: 'url("img/bg/bg-03.png")'}}>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="section-heading text-center">                            
                            <h2 class="h1 mb-0">Our Laboratories</h2>
                        </div>
                    </div>
                </div>
                <div class="row mt-n1-9">
                    <div class="col-sm-6 col-lg-4 col-xl-3 mt-1-9">
                        <a href="courses-list.html" class="category-item-01">
                            <div class="category-img">
                                <img src="img/icons/icon04.png" className='icon_img' alt="" />
                            </div>
                            <div class="ms-3">
                                <h3 class="h4 mb-0 text-black">Pharmaceutics Lab</h3>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 col-lg-4 col-xl-3 mt-1-9">
                        <a href="courses-list.html" class="category-item-01">
                            <div class="category-img">
                                <img src="img/icons/icon05.png" className='icon_img' alt="" />
                            </div>
                            <div class="ms-3">
                                <h3 class="h4 mb-0 text-black">Model Pharmacy</h3>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 col-lg-4 col-xl-3 mt-1-9">
                        <a href="courses-list.html" class="category-item-01">
                            <div class="category-img">
                                <img src="img/icons/icon01.png" className='icon_img' alt="" />
                            </div>
                            <div class="ms-3">
                                <h3 class="h4 mb-0 text-black">Human Anatomy</h3>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 col-lg-4 col-xl-3 mt-1-9">
                        <a href="courses-list.html" class="category-item-01">
                            <div class="category-img">
                                <img src="img/icons/icon06.png" className='icon_img' alt="" />
                            </div>
                            <div class="ms-3">
                                <h3 class="h4 mb-0 text-black">Pharmaceutical Chemistry Lab</h3>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 col-lg-4 col-xl-3 mt-1-9">
                        <a href="courses-list.html" class="category-item-01">
                            <div class="category-img">
                                <img src="img/icons/icon02.png" className='icon_img' alt="" />
                            </div>
                            <div class="ms-3">
                                <h3 class="h4 mb-0 text-black">Pharmacology Lab</h3>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 col-lg-4 col-xl-3 mt-1-9">
                        <a href="courses-list.html" class="category-item-01">
                            <div class="category-img">
                                <img src="img/icons/icon03.png" className='icon_img' alt="" />
                            </div>
                            <div class="ms-3">
                                <h3 class="h4 mb-0 text-black">Pharmacognosy Lab</h3>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 col-lg-4 col-xl-3 mt-1-9">
                        <a href="courses-list.html" class="category-item-01">
                            <div class="category-img">
                                <img src="img/icons/icon07.png" className='icon_img' alt="" />
                            </div>
                            <div class="ms-3">
                                <h3 class="h4 mb-0 text-black">Pharmacy Practice Lab</h3>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 col-lg-4 col-xl-3 mt-1-9">
                        <a href="courses-list.html" class="category-item-01">
                            <div class="category-img">
                                <img src="img/icons/icon08.png" className='icon_img' alt="" />
                            </div>
                            <div class="ms-3">
                                <h3 class="h4 mb-0 text-black">Pathology lab</h3>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        {/* // <!-- ONLINE INSTRUCTORS
        // ================================================== --> */}


        <section class="bg-very-light-gray">
            <div class="container">
                <div class="section-heading">                   
                    <h2 class="h1 mb-0">Gallery</h2>
                </div>
                <div class="row g-xxl-5 mt-n2-6">
                    <div class="col-md-6 col-xl-4 mt-2-6">
                        <div class="card card-style1 p-0 h-100">
                            <div class="card-img rounded-0">
                                <div class="image-hover">
                                    <img class="rounded-top" src="img/content/classroom1.png" alt="..." />
                                </div>                               
                            </div>                            
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4 mt-2-6">
                        <div class="card card-style1 p-0 h-100">
                            <div class="card-img rounded-0">
                                <div class="image-hover">
                                    <img class="rounded-top" src="img/content/classroom2.png" alt="..." />
                                </div>                               
                            </div>                            
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4 mt-2-6">
                        <div class="card card-style1 p-0 h-100">
                            <div class="card-img rounded-0">
                                <div class="image-hover">
                                    <img class="rounded-top" src="img/content/classroom3.png" alt="..." />
                                </div>                               
                            </div>                            
                        </div>
                    </div>

                    <div class="col-md-6 col-xl-4 mt-2-6">
                        <div class="card card-style1 p-0 h-100">
                            <div class="card-img rounded-0">
                                <div class="image-hover">
                                    <img class="rounded-top" src="img/content/classroom4.png" alt="..." />
                                </div>                               
                            </div>                            
                        </div>
                    </div>

                   

                    <div class="col-md-6 col-xl-4 mt-2-6">
                        <div class="card card-style1 p-0 h-100">
                            <div class="card-img rounded-0">
                                <div class="image-hover">
                                    <img class="rounded-top" src="img/content/library1.png" alt="..." />
                                </div>                               
                            </div>                            
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4 mt-2-6">
                        <div class="card card-style1 p-0 h-100">
                            <div class="card-img rounded-0">
                                <div class="image-hover">
                                    <img class="rounded-top" src="img/content/library2.png" alt="..." />
                                </div>                               
                            </div>                            
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>

       

        <section class="p-0">
                <iframe width="100%" height="500" id="gmap_canvas" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.902099342612!2d80.86075047521837!3d26.747500076745915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bf9053d3ed689%3A0xa249fc357af8d08e!2s227101%2C%20Kanpur%20Rd%2C%20Sarojini%20Nagar%2C%20Lucknow%2C%20Uttar%20Pradesh%20226008!5e0!3m2!1sen!2sin!4v1715508274060!5m2!1sen!2sin"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

        </section>

        {isOpen && (<div class="modal d-block z-10 bd-example-modal-lg" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header p-0">					
					<button type="button" onClick={closePopup} class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body p-0">
					 <img src='img/content/model.jpeg' alt='' />
				</div>
			
			</div>
		</div>
	</div>  )}
    </>
  )
}

export default Home
